import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
function AppStoreRedirect() {
  useEffect(() => {
    window.location.href = 'https://apps.apple.com/us/app/emigo-better-texting/id6748092950';
  }, []);
  return null;
}
import Navbar from './components/Navbar';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import PricingSection from './components/PricingSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import FooterUtilityBar from './components/FooterUtilityBar';
import PrivacySection from './components/PrivacySection';
import { SectionDivider } from './components/SectionDivider';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
function HomePage() {
  return <>
      <main className="flex-grow" data-id="element-0">
        <FeaturesSection data-id="element-1" />
        <SectionDivider data-id="element-2" />
        <PrivacySection data-id="element-3" />
        <FAQSection data-id="element-4" />
        <FooterUtilityBar data-id="element-5" />
        <PricingSection data-id="element-6" />
      </main>
    </>;
}
export function App() {
  document.title = 'Emigo';
  return <BrowserRouter data-id="element-7">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-8">
        <Routes data-id="element-9">
          <Route path="/" element={<HomePage data-id="element-11" />} data-id="element-10" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-13" />} data-id="element-12" />
          <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-15" />} data-id="element-14" />
          <Route path="/ig" element={<AppStoreRedirect data-id="element-17" />} data-id="element-16" />
          <Route path="/tiktok" element={<AppStoreRedirect data-id="element-19" />} data-id="element-18" />
        </Routes>
      </div>
    </BrowserRouter>;
}